import React, { useEffect, useState } from 'react';
import { Tab, Tabs } from '@mui/material';

import { MainContainer } from '../../styles/styles';
import PageHeader from '../../presentation/layout/PageHeader/PageHeader';
import { TranslationKeys } from '../../i18n/locales/defaultResources';
import { useI18n } from '../../hooks/useI18n';
import { DeliveryPlanSection, SectionTitle } from './styles';
import DeliveryPlanSettings from '../../presentation/features/delivery/DeliveryPlanSettings/DeliveryPlanSettings';
import SecurityTrim, {
  SecurityTrimMode,
} from '../../services/auth/SecurityTrim';
import ServiceProviderSettings from '../../presentation/features/settings/ServiceProviderSettings/ServiceProviderSettings';
import { CropConnectRoleDefinitions } from '../../services/cropConnectApiClient';
import Survey from '../Survey/Survey';
import { useContextStore } from '../../stores/storeRoot';

const Administration = () => {
  const { t } = useI18n();
  const [activeTab, setActiveTab] = useState('');
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const { globalAssignment } = useContextStore();

  const tabs = [];
  if (
    globalAssignment?.roles?.some(
      (r) => r === CropConnectRoleDefinitions.DeliveryPlanAdmin
    )
  ) {
    tabs.push(
      <Tab
        key="delivery_plan"
        label={t(TranslationKeys.administration_tab_delivery_plan)}
      />
    );
  }

  if (
    globalAssignment?.roles?.some(
      (r) => r === CropConnectRoleDefinitions.RedCertAdmin
    )
  ) {
    tabs.push(
      <Tab
        key="redcert"
        label={t(TranslationKeys.administration_tab_redcert)}
      />
    );
  }

  useEffect(() => {
    // if (
    //   globalAssignment?.roles?.some(
    //     (r) => r === CropConnectRoleDefinitions.DeliveryPlanAdmin
    //   )
    // ) {
    //   setActiveTab('delivery_plan');
    // }
    setActiveTab(tabs[0]?.key);
    setActiveTabIndex(0);
  }, [globalAssignment]);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(tabs[newValue].key);
    setActiveTabIndex(newValue);
  };

  return (
    <MainContainer>
      <PageHeader title={t(TranslationKeys.administrationPage_title)} />

      <Tabs value={activeTabIndex} onChange={handleTabChange}>
        {tabs}
      </Tabs>

      {activeTab === 'delivery_plan' && (
        <DeliveryPlanSection>
          <SecurityTrim
            onlyNordzuckerInternalUsers
            requiredGlobalRoles={[
              CropConnectRoleDefinitions.GlobalAdmin,
              CropConnectRoleDefinitions.DeliveryPlanAdmin,
            ]}
            securityTrimMode={SecurityTrimMode.AND}
          >
            <SectionTitle>
              {t(TranslationKeys.administration_delivery_plan_section_title)}
            </SectionTitle>
            <DeliveryPlanSettings />
          </SecurityTrim>
          <SecurityTrim
            requiredBusinessPartnerRoles={[
              CropConnectRoleDefinitions.ServiceProvider,
            ]}
          >
            <ServiceProviderSettings />
          </SecurityTrim>
        </DeliveryPlanSection>
      )}

      {activeTab === 'redcert' && <Survey />}
    </MainContainer>
  );
};

export default Administration;
